<div class="wrapper">
    <div class="hdr">
        <h2 mat-dialog-title>Add Attachment</h2>
        <div class="mini-close">
            <button matIconButton mat-dialog-close class="btn-close-top" aria-label="Close session manager.">
                <mat-icon fontIcon="close"/>
            </button>
        </div>
    </div>

    <mat-dialog-content class="mat-typography">
        <mat-tab-group
            [(selectedIndex)]="activeTabIndex"
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            animationDuration="0ms">
            <mat-tab label="File Upload">
                <div class="tab-content">
                    <h3>Select a file from your device</h3>
                    <div>Uploaded files are saved to your <strong>Apps\AI Assist\Uploads</strong> OneDrive folder. Files will be uploaded automatically after selection.</div>

                    <form [formGroup]="uploadFileForm" novalidate>
                        <div class="file-select-wrapper">
                            <kendo-fileselect
                                class="file-select"
                                #myFileSelect="kendoFileSelect"
                                (select)="onSelectFileEvent($event)"
                                [restrictions]="fileRestrictions"
                                formControlName="files"
                                [multiple]="true">

                                <ng-template kendoFileSelectFileTemplate let-files let-state="state">
                                <div style="display: flex; flex-direction: column">
                                    <div class="file-details">
                                        <div>{{ files[0].name }} Size: {{ files[0].size }} bytes</div>
                                        @if (showButton(state)) {
                                            <button
                                                kendoButton
                                                type="button"
                                                (click)="removeFileFromFileSelect(myFileSelect, files[0].uid)"
                                                [svgIcon]="xOutlineIcon"
                                                fillMode="clear"
                                                style="position: absolute; right: .2em;"
                                                title="Remove file"></button>
                                        }
                                    </div>
                                    @if (files[0].size > fileRestrictions.maxFileSize!) {
                                    <div class="file-error">
                                    File size exceeds the maximum allowed size of {{ fileRestrictions.maxFileSize! / 1024 }} KB
                                    </div>
                                    }
                                </div>
                                </ng-template>
                            </kendo-fileselect>
                        </div>

                        <mat-hint>Maximum file size is {{fileRestrictions.maxFileSize! / 1024}} KB.</mat-hint>
                    </form>
                </div>
            </mat-tab>

            <mat-tab label="OneDrive">
                <div class="tab-content">
                    <form [formGroup]="searchForm" (ngSubmit)="search()">
                        <mat-form-field class="input-field">
                            <mat-label>Search for files in your OneDrive</mat-label>
                            <input
                                matInput
                                cdkFocusInitial
                                formControlName="search" />
                            <button type="submit"
                                class="btn-search"
                                [disabled]="searchForm.get('search')!.value === ''"
                                    matFab
                                    aria-label="Search for files in your OneDrive"
                                matSuffix>
                                <mat-icon fontIcon="search" aria-hidden="true"/>
                            </button>
                        </mat-form-field>
                    </form>

                    <div class="doc-list-wrapper">
                        <div class="doc-list">
                        @if (data.length > 0 ) {
                            <div class="statement">
                              <span>Click the</span>
                              <mat-icon aria-hidden="false" aria-label="plus" class="material-symbols-outlined icon-tree-item-plus icon-sm" fontIcon="add_circle"/>
                              <span>to add a file from your OneDrive.</span></div>
                            <kendo-treeview
                                class="doc-tree"
                                [nodes]="data"
                                textField="text"
                                [hasChildren]="hasChildren"
                                kendoTreeViewHierarchyBinding
                                childrenField="items"
                                [filterable]="filterable"
                                kendoTreeViewExpandable
                                [expandedKeys]="expandedKeys"
                                kendoTreeViewSelectable
                                [(selectedKeys)]="selectedKeys"
                                (selectionChange)="onTreeSelectionChange($event)"
                                >
                                <ng-template kendoTreeViewNodeTemplate let-dataItem>
                                    <div class="doc-tree-item">
                                      @if (isFileItem(dataItem)) {
                                        <mat-icon
                                          [class]="iconClass(dataItem)"
                                          class="material-symbols-outlined icon-sm"
                                          [fontIcon]="isFileListed(dataItem)"
                                          aria-hidden="false"
                                          aria-label="plus">
                                        </mat-icon>
                                      }

<!--                                        <span [ngClass]="iconClass(dataItem)"></span>-->
                                        <span>{{ dataItem.text }}</span>
                                    </div>
                                </ng-template>
                            </kendo-treeview>
                        }
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

        <!-- Selected documents section (outside tabs) -->
        <div class="selected-docs">
            <h3>Your currently attached documents</h3>
            <mat-hint class="hint">The maximum number of documents is {{maxDocuments}}.</mat-hint>
            @if (chatDocumentService.selectedDocuments().length > 0){
                <kendo-listview
                    [data]="chatDocumentService.selectedDocuments()"
                    containerClass="k-d-flex k-flex-col k-flex-nowrap selected-docs-list">
                    <ng-template
                        kendoListViewItemTemplate
                        let-dataItem="dataItem"
                        let-index="index"
                        let-isFirst="isFirst"
                        let-isLast="isLast">
                        <div class="selected-doc" [class.border-bottom]="!isLast">
                            <button
                                type="button"
                                kendoButton
                                fillMode="clear"
                                (click)="removeDocFromList(dataItem)"
                                [svgIcon]="minusOutlineIcon"
                                title="Remove Document"></button>
                          <attachment-doc [document]="dataItem"></attachment-doc>
                        </div>
                    </ng-template>
                </kendo-listview>
                <div class="total-docs">Total: {{chatDocumentService.selectedDocuments().length}}</div>
            }
        </div>

        <!-- Error files table -->
        @if (errorFiles.length > 0) {
            <div class="error-files-section">
                <h3>Files with Upload Errors</h3>
                <kendo-grid
                  class="table-wrapper"
                  [data]="errorFiles"
                  [sortable]="true"
                  [resizable]="true"
                  [scrollable]="'none'"
                >

                  <!-- File Name Column -->
                  <kendo-grid-column field="name" title="File Name" [width]="200">
                  </kendo-grid-column>

                  <!-- Sensitivity Label Column -->
                  @if (slEnabled()) {
                  <kendo-grid-column field="sensitivityLabel" title="Sensitivity Label" [width]="180">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{getSensitivityLabelDisplay(dataItem.sensitivityLabel)}}
                    </ng-template>
                  </kendo-grid-column>
                  }

                  <!-- Reason Column -->
                  <kendo-grid-column field="reason" title="Reason" [width]="400">
                  </kendo-grid-column>
                </kendo-grid>
            </div>
        }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button matButton mat-dialog-close>Cancel</button>
        <button matButton="filled"
            class="btn-confirm"
            [mat-dialog-close]="true"
            [disabled]="chatDocumentService.selectedDocuments().length === 0">Attach files</button>
    </mat-dialog-actions>
</div>
